import { render, staticRenderFns } from "./FarmFireRiskChart.vue?vue&type=template&id=aa518b62"
import script from "./FarmFireRiskChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./FarmFireRiskChart.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports